module.exports = __webpack_public_path__ + "static/img/prize_no.db15c1de.png";